<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/R5zUcY/tc-custom/9781399084635.jpg?1736424010979" alt="This image is the cover for the book Arthur, Prince of Wales"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Arthur, Prince of Wales
      </h1>
      <p class="bookDescription body article font2">
        <p>For too long, Arthur Tudor has been remembered only for what he never became. The boy who died prematurely and paved the way for the revolutionary reign of his younger brother, Henry VIII.  Yet, during his short life, Arthur was at the center of one of the most tumultuous periods of England’s history. At the time of his birth, he represented his father’s hopes for a dynasty and England’s greatest chance of peace. As he grew, he witnessed feuds, survived rebellion and became the focal point of an international alliance.  From the threat of pretenders to West Country rebellions, the dramatic twists and turns of early Tudor England preoccupied Arthur’s thoughts. At a young age, he was dispatched to the Welsh border, becoming a figure head for a robust regional government. While never old enough to exercise full power in his dominion, he emerged as a figure of influence, beseeched by petitioners and consulted by courtiers. While the extent of his personal influence can only be guessed at, the sources that survive reveal a determined prince that came tantalizingly close to forging his future.  Finally, after years of negotiation, delay and frustration, the prince finally came face to face with his Spanish bride, Katharine of Aragon. The young couple had shared a destiny since the cradle. Securing the hand of this prestigious pride for his son had been a center piece of Henry VII’s foreign policy. Yet, despite being 14 years in the making, the couple were to enjoy just five months together before Arthur succumbed to a mysterious illness.  Arthur’s death at the age of 15 was not just a personal tragedy for his parents. It changed the course of the future and deprived England of one of the most educated and cultivated princes in their history. Arthur would never wear the crown the of England. But few Princes of Wales had been better prepared to rule.  Arthur, Prince of Wales: Henry VIII’s Lost Brother shows that Arthur Tudor was more than a prince who died. He was a boy that really lived.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gareth Streeter
      </h2>
      
      <p class="authorDescription body article">Gareth Streeter is a Royal history researcher and writer with a specialist interest in the wars of the roses and the early Tudor period. He is the creator of “Royal History Geeks”, a blog and social media experience that engages with 50,000 history lovers across facebook, Twitter, Instagram and YouTube.  Gareth is passionate about telling the stories of the people that helped forged the United Kingdom. He is driven by a belief that by a profound understanding of our own history – as a nation and as people – we can more adequately address the challenges of the future.  As well as his interest in factual writing, Gareth is the author of several short stories about figures from history which are available online.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?61401612